<template>
    <div class="learn">
        <div class="search-top"> 
            <el-input class="search-input" type='text' v-model="searchName"></el-input>
            <el-button  type="primary" >检索</el-button>
            <el-select class="search-select" v-model="learnType" placeholder="请选择">
                <el-option
                v-for="item in learnOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="learn-table">
            <el-table  
                style="width: 100%; margin-top: 30px"
                :data="tableList"
                :header-cell-style="{background:'#386DE8',color:'#fff'}"
                :row-class-name="tableRowClassName"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column align="center"  label="条文号" width="200" prop="storeNum"> </el-table-column>
                <el-table-column align="center"  label="伤寒条文"   prop="storeNum"> </el-table-column>
                <el-table-column align="center"  label="六经辨证" width="200" prop="storeNum"> </el-table-column>
                <el-table-column align="center"  label="操作" show-overflow-tooltip width="200">
                    <template slot-scope="scope">
                        <el-button class="table-column-btn" type="text"    @click="toDetails(scope.row)">查看</el-button>
                        <span>未背诵</span>
                                        
                    </template>
                </el-table-column> 
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchName:'',
            learnType:'',
            learnOptions:[
                {
                    value: 'all',
                    label: '全部'
                }, {
                    value: 'yes',
                    label: '已背诵'
                }, {
                    value: 'no',
                    label: '未背诵'
                }, 
            ],
            tableList:[],
        }
    },
    methods: {
         //table隔行变色
        tableRowClassName({ row, rowIndex }) {
            row.rowIndex = rowIndex;
            if ((rowIndex-1) % 2 === 0) {
                return 'success-row' //这是类名
            } else  {
                return ''
            }
        },
        toDetails(row){

        }
    }
}
</script>
<style lang="less" scoped>
.learn{
    ::v-deep .el-input__inner{
        border:none;
    }
    .search-top{
        width: 1100px;
        margin: 20px auto;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .search-input{
            width: 800px;
            border:1px solid #386DE8;
            border-radius: 4px;
        }
        .search-select{
            border:1px solid #386DE8;
            border-radius: 4px;
            width: 140px;
        }
    }
}
</style>